import { render } from "./Percival.vue?vue&type=template&id=295caf2a&scoped=true&ts=true"
import script from "./Percival.vue?vue&type=script&lang=ts"
export * from "./Percival.vue?vue&type=script&lang=ts"

import "./Percival.vue?vue&type=style&index=0&id=295caf2a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295caf2a"]])

export default __exports__